import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import { bucketManager, defaultToastOptions, groupContext, openLoginMenu, setDTConfig, } from "../index.js";
import { useGlobalUpdate } from "../../scripts/useGlobalUpdate.js";
import FormatsCountSelector from "../formatsCountSelector/formatsCountSelector.js";
import { UpdateBasketItemsCount } from "../navbar/navBar.js";
import "./style.css";
import ImageComponent from "../image/image.js";
export default function FormCategory(props) {
    var _a, _b, _c;
    const { category, categoryIndex } = props;
    const group = useContext(groupContext);
    const offer = category.offers[0];
    const format = offer.formats[0];
    const [_, setUpdate] = useState(0);
    const { useListener, emit } = useGlobalUpdate(UpdateBasketItemsCount);
    useListener(setUpdate);
    const image = category.images[0];
    const isOrdered = bucketManager.Bucket.hasOrder(image.name, offer.name);
    async function orderCurrentElement(formats) {
        var _a, _b;
        if (bucketManager.Bucket.hasOrder(category.name, offer.name)) {
            toast.error("Element jest już w koszyku.", defaultToastOptions);
            return;
        }
        try {
            await bucketManager.insertOrder(category.images[0].name, {
                ...offer,
                formats,
            });
            toast.success("Dodano do koszyka.", defaultToastOptions);
            emit(bucketManager.Bucket.orders.length);
        }
        catch (err) {
            if (err == 403) {
                openLoginMenu({
                    needsEmail: group.clientData.email,
                    needsName: group.clientData.name,
                    needsPhone: group.clientData.phone,
                    flow: (_a = group.flow) === null || _a === void 0 ? void 0 : _a.onFirstOrderIntent,
                    componentList: (_b = group === null || group === void 0 ? void 0 : group.flow) === null || _b === void 0 ? void 0 : _b.componentsList,
                    onLogin() {
                        setDTConfig((c) => ({ ...c, isLoggedIn: "true" }));
                        orderCurrentElement(formats);
                    },
                    onExit() { },
                    allowLoginToOrder: group.allowLoginToOrder,
                });
                return;
            }
            toast.error("Nie udało się dodać elementu do koszyka.", defaultToastOptions);
        }
    }
    if (isOrdered) {
        return React.createElement(React.Fragment, null);
    }
    const imageLoader = (_b = (_a = group === null || group === void 0 ? void 0 : group.appearance) === null || _a === void 0 ? void 0 : _a.imageLoader) !== null && _b !== void 0 ? _b : "default-engine";
    return (React.createElement("div", { className: "form-category-container" },
        image.name !== category.name && (React.createElement(ImageComponent, { inView: true, groupId: group._id, imageLoader: imageLoader, galleryName: group === null || group === void 0 ? void 0 : group.galleryName, imageName: image.name, offers: [], aspectRatio: (_c = image.aspectRatio) !== null && _c !== void 0 ? _c : undefined })),
        React.createElement(FormatsCountSelector, { formatNames: [format.name], offer: offer, onAccept: orderCurrentElement, onReject: () => { }, withoutGoBackButton: true, isLoading: false })));
}
